import * as React from 'react';
import moment, { Moment } from 'moment-timezone';
import { ISODateTime, TimeRange } from '../../types/date';
import classNames from 'classnames';
import './timeRange.module.scss';

type DateProps = {
  date: ISODateTime | Moment;
};
export const SimpleDate = ({ date }: DateProps) => <span>{moment(date).format('M月D日')}</span>;
export const DetailedDate = ({ date }: DateProps) => <span>{moment(date).format('YY年M月D日')}</span>;
export const DetailedDate2 = ({ date }: DateProps) => <span>{moment(date).format('YYYY/MM/DD')}</span>;

const WEEKDAY_LABELS = ['月', '火', '水', '木', '金', '土', '日'];

export const SimpleDateWithWeekday = ({ date }: DateProps) => {
  const parsedDate = moment(date);
  const dateText = parsedDate.format('MM/DD');
  const weekday = parsedDate.isoWeekday();
  const weekdayText = WEEKDAY_LABELS[weekday - 1];
  const saturday = weekday === 6;
  const sunday = weekday === 7;
  return (
    <span>
      {dateText}
      <span>
        (<span styleName={classNames({ sunday: sunday, saturday: saturday })}>{weekdayText}</span>)
      </span>
    </span>
  );
};

type RangeProps = {
  range: TimeRange;
};

export const SimpleTimeRange = ({ range }: RangeProps) => (
  <span>
    {moment(range.starts_at).format('HH時mm分')}〜{moment(range.ends_at).format('HH時mm分')}
  </span>
);

export const DetailedDateTime = ({ date }: DateProps) => <span>{moment(date).format('YYYY年M月D日 HH時mm分')}</span>;

export const DetailedDateRange = ({ fromDate, toDate }) => (
  <span>
    {moment(fromDate).format('YYYY年M月D日')}〜{toDate && moment(toDate).format('YYYY年M月D日')}
  </span>
);

export const DetailedPeriod = ({ startsAt, expiresAt }) => (
  <span>
    {startsAt && moment(startsAt).format('YYYY年M月D日')}〜
    {expiresAt && moment(expiresAt).subtract(1, 'd').format('YYYY年M月D日23:59')}
  </span>
);
